import * as React from "react";
import { LoadingButton, LoadingButtonProps } from "@mui/lab";
import { useMediaQuery, useTheme } from "@mui/material";

export interface SaveButtonProps extends Omit<LoadingButtonProps, "variant" | "color"> {
  label?: string;
  saveLabel?: string;
  updateLabel?: string;
  isUpdate?: boolean;
}

/**
 * Global Save/Update button component with orange color (#F4A259)
 * Automatically shows "Save" or "Update" based on isUpdate prop
 */
const SaveButton: React.FC<SaveButtonProps> = ({
  label,
  saveLabel = "Save",
  updateLabel = "Update",
  isUpdate = false,
  size = "large",
  sx,
  ...props
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const buttonText = label || (isUpdate ? updateLabel : saveLabel);

  return (
    <LoadingButton
      type="submit"
      variant="contained"
      size={size}
      {...props}
      sx={{
        backgroundColor: "#F4A259",
        color: "#ffffff",
        fontWeight: 600,
        "&:hover": {
          backgroundColor: "#E8944A",
        },
        "&:disabled": {
          backgroundColor: "rgba(244, 162, 89, 0.5)",
          color: "rgba(255, 255, 255, 0.7)",
        },
        "& .MuiLoadingButton-loadingIndicator": {
          color: "#ffffff",
        },
        width: isMobile ? "100%" : "auto",
        ...sx,
      }}
    >
      {buttonText}
    </LoadingButton>
  );
};

export default SaveButton;

